import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/utils/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import CampusOutreach from './pages/CampusOutreach';
import CityOutreach from './pages/CityOutreach';
import Testimonies from './pages/Testimonies';
import Events from './pages/Events';
import Donate from './pages/Donate';
import GetInvolved from './pages/GetInvolved';
import Contact from './pages/Contact';
import Videos from './pages/Videos';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/campus-outreach" element={<CampusOutreach />} />
            <Route path="/city-outreach" element={<CityOutreach />} />
            <Route path="/testimonies" element={<Testimonies />} />
            <Route path="/events" element={<Events />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;